export const getContentfulImageUrl = (contentfulImageAsset: string): string =>
  `https:${contentfulImageAsset}`;
